import { useCallback, useState } from "react";
import AssetModelTableComponent from "./asset-model-table.component";
import TableSort from "../../../../../shared/helpers/table-sort";
import capitalizeFirst from "../../../../../shared/helpers/upper-case";
import { useQuery } from "@tanstack/react-query";
import { getAssetModels } from "../../../../../core/api/services/assetModel.service";

const AssetModelComponent = () => {
  const [PageNumber, setPageNum] = useState<number>(1);
  const [assetModelSearchValue, setAssetModelSearchValue] = useState("");
  const pageSize = 10;

  const [SortBy, setSortBy] = useState<any>(capitalizeFirst("assetModelCode"));
  const [SortDirection, setSortDirection] = useState<any>("desc");

  const [columns, setColumns] = useState([
    {
      title: "Model",
      label: "assetModelCode",
      isSorted: true,
    },
    {
      title: "Asset Type",
      label: "assetType",
      // width: "8rem"
    },
    {
      title: "Supplier",
      label: "SLSSupplier",
      // width: "8rem"
    },
    {
      title: "Rated Watt",
      label: "ratedWatt",
      // width: "8rem"
    },
    {
      title: "Expected Lifetime",
      label: "expectedLifeTime",
      // width: "10rem"
    },
  ]);

  const {
    data: assetModels,
    isLoading: isLoadingAssetModels,
    refetch,
  } = useQuery({
    queryKey: [
      "getAssetModels",
      PageNumber,
      SortBy,
      SortDirection,
      assetModelSearchValue,
    ],
    queryFn: ({ signal }) =>
      getAssetModels(
        PageNumber,
        pageSize,
        SortBy,
        SortDirection,
        assetModelSearchValue,
        signal
      ),
  });

  const onRefetchData = () => {
    if (assetModels?.numberOfRecords <= pageSize + 1) {
      setPageNum(1);
    }
    refetch();
  };

  const handleChangePage = useCallback((page: number): void => {
    setPageNum(page);
  }, []);

  const handleSearch = useCallback((searchVal: string): void => {
    setPageNum(1);
    setAssetModelSearchValue(searchVal);
  }, []);

  const handleChangeSort = useCallback(
    async (sortBy: string, sortDirection: any) => {
      if (!sortBy || !sortDirection) return;
      setSortBy(sortBy);
      setSortDirection(sortDirection);

      const copyColumns: any = await TableSort(columns, sortBy);
      setColumns(copyColumns);
    },
    []
  );

  return (
    <div>
      <AssetModelTableComponent
        columns={columns}
        data={assetModels?.data}
        totalNumberOfRecords={assetModels?.numberOfRecords}
        pageSize={pageSize}
        current={PageNumber}
        onChangePage={handleChangePage}
        onRefetchData={onRefetchData}
        onChangeSort={handleChangeSort}
        isLoading={isLoadingAssetModels}
        onSearch={handleSearch}
        assetModelSearchValue={assetModelSearchValue}
      />
    </div>
  );
};

export default AssetModelComponent;
